import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

interface DrawerBodyWrapperProps {
  gap?: string
  withPadding?: boolean
}

export const DrawerBodyWrapper = styled.div<DrawerBodyWrapperProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ gap }) => gap ?? Spacing.S16};
  width: 100%;
  ${({ withPadding }) => withPadding && `padding: ${Spacing.S16} ${Spacing.S24};`}
  overflow-y: auto;
`
